import { render } from "./Dashboard.vue?vue&type=template&id=72756f50"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script